module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('h5', [_vm._v("退藥理由"), _c('button', {
    staticClass: "btn btn-sm btn-info icon-right",
    on: {
      "click": function($event) {
        _vm.createReason = !_vm.createReason
      }
    }
  }, [_vm._v("新增退藥理由")])]), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.createReason) ? _c('div', {
    staticClass: "create-form"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason),
      expression: "reason"
    }],
    staticClass: "form-control mr-2",
    attrs: {
      "type": "text",
      "placeholder": "輸入欲新增理由"
    },
    domProps: {
      "value": (_vm.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reason = $event.target.value
      }
    }
  }), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.addReason
    }
  }, [_vm._v("新增")])])]) : _vm._e()]), _c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _c('tbody', _vm._l((_vm.returnReason), function(reason, ind) {
    return _c('tr', [_c('th', [_vm._v(_vm._s(reason))]), _c('th', [_c('button', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          return _vm.deleteReason(ind)
        }
      }
    }, [_vm._v("刪除")])])])
  }), 0)])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("理由")]), _c('th', [_vm._v("動作")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-143b7a68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/SystemSettings/GeneralSettings.vue
// module id = 1398
// module chunks = 1